const configs = {
    development: {
        invalidPaymentReasons: [
            "not in list",
            "no payment",
            "exit.w.e",
            "exit.w.e.",
            "in free time",
            "exit.w.e;after end date;",
            "exit.w.e;",
            'black list'
        ],
        apiUrl: "https://app.bluept.dev",
        mode: "development",
        rtc: {
            serverUrl: "https://rtc.bluept.dev",
        },
        app: {
            serverUrl: "https://app.bluept.dev",
        },
    },
    test: {
        invalidPaymentReasons: [
            "not in list",
            "no payment",
            "exit.w.e",
            "exit.w.e.",
            "in free time",
            "exit.w.e;after end date;",
            "exit.w.e;",
            'black list'
        ],
        apiUrl: "https://app.bluept.dev",
        mode: "test",
        rtc: {
            serverUrl: "https://rtc.bluept.dev",
        },
        app: {
            serverUrl: "https://app.bluept.dev",
        },
    },
    production: {
        invalidPaymentReasons: [
            "not in list",
            "no payment",
            "exit.w.e",
            "exit.w.e.",
            "in free time",
            "exit.w.e;after end date;",
            "exit.w.e;",
            'black list'
        ],
        apiUrl: "https://app.bluept.cloud",
        mode: "production",
        rtc: {
            serverUrl: "https://rtc.bluept.cloud",
        },
        app: {
            serverUrl: "https://app.bluept.cloud",
        },
    },
};

// Determine the environment (default to development if not set)
//for prod change this to "production" only
const env = "production";

export default configs[env];
